import React from 'react';
import Divider from '@material-ui/core/Divider';

// eslint-disable-next-line
import style from './_style.css';

class Index extends React.Component {
    render() {
        return (
            <div className={'divider'}>
                <Divider />
            </div>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/navbar/user/Divider.js